<template>
    <router-view />
</template>

<script>
export default {
  name: "HomeModule"
};
</script>